import { isEmptyObject } from '../../helper/utils/isEmptyObject';
import { getPriceModifier, getPriceModifierDiscount, getPriceModifierService, getPriceModifierTax } from './modifier';
import { getRounded, isRounded } from './rounded';
import { totalServiceValue } from './service';
import { totalTaxValue } from './tax';

export function getPriceMenu(menu = {}, salesOrderData = {}) {
    if (!isEmptyObject(menu)) {
        const qty = parseFloat((menu['qty'] || 0).toString());
        const price = parseFloat((menu[`Price${salesOrderData['SalesTypeCode']}`] || 0).toString());

        return qty * price + getPriceModifier(menu, salesOrderData);
    }

    return 0;
}

export function getPriceMenuAfterTax(menu = {}, salesOrderData = {}) {
    if (!isEmptyObject(menu)) {
        return getPriceMenu(menu, salesOrderData) + getPriceMenuTax(menu) + getPriceMenuService(menu);
    }

    return 0;
}

export function getPriceMenuDiscount(menu = {}) {
    if (!isEmptyObject(menu)) {
        return parseFloat((menu['discValuex'] || 0).toString()) + getPriceModifierDiscount(menu);
    }

    return 0;
}

export function getPriceMenuTax(menu = {}) {
    if (!isEmptyObject(menu)) {
        return parseFloat((menu['taxVal'] || 0).toString()) + getPriceModifierTax(menu);
    }

    return 0;
}

export function getPriceMenuService(menu = {}) {
    if (!isEmptyObject(menu)) {
        return parseFloat((menu['servVal'] || 0).toString()) + getPriceModifierService(menu);
    }

    return 0;
}

export function getGrandTotalPriceMenu(menu = {}, salesOrderData = {}) {
    if (!isEmptyObject(menu)) {
        return getPriceMenu(menu, salesOrderData) - getPriceMenuDiscount(menu);
    }

    return 0;
}

export function getTotalPricesMenu(items = [], salesOrderData = {}) {
    if (items.length > 0) {
        return getItemsNoVoid(items)
            .map((item) => getPriceMenu(item, salesOrderData))
            .reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
    }

    return 0;
}

export function getTotalServicesMenu(items = []) {
    if (items.length > 0) {
        return getItemsNoVoid(items)
            ?.map((item) => getPriceMenuService(item))
            .reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
    }

    return 0;
}

export function getTotalTaxesMenu(items = []) {
    if (items.length > 0) {
        return getItemsNoVoid(items)
            ?.map((item) => getPriceMenuTax(item))
            .reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
    }

    return 0;
}

export function getTotalQtyMenu(items = []) {
    if (items.length > 0) {
        return getItemsNoVoid(items)?.reduce((qty, item) => parseFloat(`${qty}`) + parseFloat(`${item['qty'] || 0}`), 0);
    }

    return 0;
}

export function getTotalDiscountsMenu(items = [], salesOrderData = {}) {
    if (items.length > 0) {
        return getItemsNoVoid(items)
            .map((item) => getPriceMenuDiscount(item, salesOrderData))
            .reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);
    }

    return 0;
}

export function getGrandTotalBeforeRounded(items = [], salesOrderData = {}) {
    return getTotalPricesMenu(items, salesOrderData) + totalServiceValue(items, salesOrderData) + totalTaxValue(items, salesOrderData) - getTotalDiscountsMenu(items, salesOrderData);
}

export function getGrandTotal(items = [], salesOrderData = {}) {
    if (isRounded()) {
        return getTotalPricesMenu(items, salesOrderData) + totalServiceValue(items, salesOrderData) + totalTaxValue(items, salesOrderData) - getTotalDiscountsMenu(items, salesOrderData) + getRounded(items, salesOrderData);
    }

    return getGrandTotalBeforeRounded(items, salesOrderData);
}

export function getGrandTotalWithoutTax(items = [], salesOrderData = {}) {
    return getGrandTotal(items, salesOrderData) - totalServiceValue(items, salesOrderData) - totalTaxValue(items, salesOrderData);
}

export function getGrandTotalWithoutTaxRounded(items = [], salesOrderData = {}) {
    return getTotalPricesMenu(items, salesOrderData) - getTotalDiscountsMenu(items, salesOrderData);
}

export const sortByOldestOrderTime = (orders) => {
    return orders.sort((a, b) => new Date(a.BillDate) - new Date(b.BillDate));
};

export const sortByXLineNo = (orders = []) => {
    if (orders.length > 0) {
        return orders.sort((a, b) => new Date(a.XLineNo) - new Date(b.XLineNo));
    }

    return [];
};

export const getItemsNoVoid = (items = []) => {
    return items?.filter((item) => (item['ItemVoid'] || false) === false);
};

export const getItemsVoid = (items = []) => {
    return items?.filter((item) => (item['ItemVoid'] || false) === true);
};

export const isCartContainRecurring = (items = []) => {
    const comboIsRecurring = items.some((item) => (item['combo'] || []).some((combo) => +combo['isRecurring'] === 1));
    // const itemsIsMembership = items.some(
    //     (item) =>
    //         String(item['productType'] || '')
    //             .trim()
    //             .toLowerCase() === 'membership',
    // );

    return comboIsRecurring;
    // || itemsIsMembership;
};

export const isItemContainRecurring = (items = []) => {
    return (items || []).some((combo) => +combo['isRecurring'] === 1);
};
